"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WeightSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M3.978 19.535a1 1 0 0 1 0-1.414L6.1 16a1 1 0 0 1 1.414 0l2.828 2.828-.706-.707a1 1 0 0 1 1.414 0l7.07-7.071a1 1 0 0 1 0-1.414l.708.707-2.829-2.829A1 1 0 0 1 16 6.1l2.122-2.121a1 1 0 0 1 1.414 0l2.12 2.121a1 1 0 0 1 1.414 0l2.83 2.83a1 1 0 0 1 0 1.414l2.121 2.121a1 1 0 0 1 0 1.414L25.9 16a1 1 0 0 1-1.414 0l-2.829-2.829.707.708a1 1 0 0 1-1.414 0l-7.071 7.07a1 1 0 0 1 0 1.415l-.707-.707L16 24.485a1 1 0 0 1 0 1.414l-2.121 2.122a1 1 0 0 1-1.414 0l-2.122-2.122a1 1 0 0 1-1.414 0L6.1 23.071a1 1 0 0 1 0-1.414l-2.122-2.122z" stroke="none"></path>';
var WeightSVG = function WeightSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.WeightSVG = WeightSVG;
WeightSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(WeightSVG);
exports.default = _default;